'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { FinalCta, styles } from '../../product-landing/ProductLanding';

export default function FinalCtaSection() {
  const { t } = useTranslation('start');
  return (
    <FinalCta title={t('mcp.finalCta.title')} intro={t('mcp.finalCta.subtitle', { defaultValue: '' })}>
      {/* No utm_* on an internal link: GA4 reads it as a new campaign and
          restarts the session on our own page (A-2026-09-21-1). */}
      <Link href="/rejestracja" className={styles.primaryButton}>
        {t('mcp.finalCta.button')}
      </Link>
    </FinalCta>
  );
}
